import { useState } from 'react'
import { useI18n } from '../i18n'

/** Нижняя шторка. Клик по фону закрывает. */
export function Sheet({ onClose, children }: { onClose: () => void; children: React.ReactNode }) {
  return (
    <div className="sheet-bg" onClick={onClose}>
      <div className="sheet" onClick={(e) => e.stopPropagation()} role="dialog">
        {children}
      </div>
    </div>
  )
}

/** «Как тебя подписать?» — единственное трение для гостя, один раз. */
export function NameSheet({
  initial, onDone, onClose,
}: { initial: string; onDone: (name: string) => void | Promise<void>; onClose?: () => void }) {
  const { t } = useI18n()
  const [name, setName] = useState(initial)
  const [busy, setBusy] = useState(false)
  const go = async () => {
    const n = name.trim()
    if (!n || busy) return
    setBusy(true)
    try { await onDone(n) } finally { setBusy(false) }
  }
  return (
    <Sheet onClose={onClose ?? (() => {})}>
      <h3>{t.dialogs.nameTitle}</h3>
      <p className="muted" style={{ fontSize: 13 }}>{t.dialogs.nameHint}</p>
      <input
        className="ans-input"
        autoFocus
        placeholder={t.dialogs.namePlaceholder}
        value={name}
        maxLength={40}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && go()}
      />
      <div className="btn-row">
        <button className="btn btn-blue" disabled={!name.trim() || busy} onClick={go}>{t.dialogs.nameGo}</button>
      </div>
    </Sheet>
  )
}

/** Переименование: личное имя (только мне), общее (всем), моё имя. */
export function RenameSheet({
  personal, shared, myName, onSave, onClose,
}: {
  personal: string
  shared: string
  myName: string
  onSave: (p: { personal: string; shared: string; myName: string }) => void | Promise<void>
  onClose: () => void
}) {
  const { t } = useI18n()
  const [p, setP] = useState(personal)
  const [s, setS] = useState(shared)
  const [n, setN] = useState(myName)
  const [busy, setBusy] = useState(false)
  const save = async () => {
    if (busy) return
    setBusy(true)
    try { await onSave({ personal: p.trim(), shared: s.trim(), myName: n.trim() }) } finally { setBusy(false) }
  }
  return (
    <Sheet onClose={onClose}>
      <h3>{t.dialogs.renameTitle}</h3>
      <label>{t.dialogs.personalLabel}<small className="muted">· {t.dialogs.personalHint}</small></label>
      <input className="ans-input" placeholder={t.dialogs.personalPlaceholder} value={p} maxLength={60} onChange={(e) => setP(e.target.value)} />
      <label>{t.dialogs.sharedLabel}<small className="muted">· {t.dialogs.sharedHint}</small></label>
      <input className="ans-input" placeholder={t.dialogs.sharedPlaceholder} value={s} maxLength={60} onChange={(e) => setS(e.target.value)} />
      <label>{t.dialogs.myNameLabel}</label>
      <input className="ans-input" placeholder={t.dialogs.namePlaceholder} value={n} maxLength={40} onChange={(e) => setN(e.target.value)} />
      <div className="btn-row">
        <button className="btn btn-ghost" onClick={onClose}>{t.dialogs.cancel}</button>
        <button className="btn btn-ink" disabled={busy || !n.trim()} onClick={save}>{t.dialogs.save}</button>
      </div>
    </Sheet>
  )
}
